exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/CarouselStandard1/CarouselStandard1.s.scss
// module id = 912
// module chunks = 16